// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "dist/js/" + chunkId + "-legacy." + {"2879":"3dee13eb","3810":"7b002590","6483":"75cf53c2","8167":"67bd91f0","9062":"a740aa7c","9326":"979c5d63"}[chunkId] + ".js";
};